// Opt in per environment; independent of marketing and future category releases.
export const ED_REDESIGN_ENABLED = process.env.REACT_APP_ED_REDESIGN === 'true';
